import { PjmRegistrationDto } from 'src/domain/pjm/dto/PjmRegistrationDto';

export enum PjmRegistrationsModal {
    CREATE = 'create',
    EDIT = 'edit',
    IMPORT = 'import',
    AUDIT = 'audit',
    UPLOAD_METER_DATA = 'uploadMeterData',
    EDIT_SEASON = 'editSeason',
    BULK_SUBMIT = 'bulkSubmit',
}

export interface ModalState {
    modal?: PjmRegistrationsModal;
    target?: PjmRegistrationDto;
}

interface EditAction {
    type: 'EDIT';
    payload: PjmRegistrationDto;
}

interface CreateAction {
    type: 'CREATE';
}

interface ImportAction {
    type: 'IMPORT';
}

interface UploadMeterDataAction {
    type: 'UPLOAD_METER_DATA';
}

interface EditSeasonAction {
    type: 'EDIT_SEASON';
}

interface AuditAction {
    type: 'AUDIT';
    payload: PjmRegistrationDto;
}

interface BulkSubmitAction {
    type: 'BULK_SUBMIT';
}

interface CloseAction {
    type: 'CLOSE';
}

export type ModalStateAction =
    | EditAction
    | CreateAction
    | ImportAction
    | UploadMeterDataAction
    | EditSeasonAction
    | AuditAction
    | BulkSubmitAction
    | CloseAction;

export function reducer(state: ModalState, action: ModalStateAction): ModalState {
    switch (action.type) {
        case 'EDIT':
            return {
                modal: PjmRegistrationsModal.EDIT,
                target: action.payload,
            };
        case 'CREATE':
            return {
                modal: PjmRegistrationsModal.CREATE,
            };
        case 'IMPORT':
            return {
                modal: PjmRegistrationsModal.IMPORT,
            };
        case 'AUDIT':
            return {
                modal: PjmRegistrationsModal.AUDIT,
                target: action.payload,
            };
        case 'UPLOAD_METER_DATA':
            return {
                modal: PjmRegistrationsModal.UPLOAD_METER_DATA,
            };
        case 'EDIT_SEASON':
            return {
                modal: PjmRegistrationsModal.EDIT_SEASON,
            };
        case 'BULK_SUBMIT':
            return {
                modal: PjmRegistrationsModal.BULK_SUBMIT,
            };
        case 'CLOSE':
            return {
                modal: undefined,
            };
        default:
            return state;
    }
}
